import { render, staticRenderFns } from "./vocTicket.vue?vue&type=template&id=0e77fbcc&scoped=true"
import script from "./vocTicket.vue?vue&type=script&lang=js"
export * from "./vocTicket.vue?vue&type=script&lang=js"
import style0 from "./vocTicket.vue?vue&type=style&index=0&id=0e77fbcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e77fbcc",
  null
  
)

export default component.exports